module.exports = __webpack_public_path__ + "img/goimage.6a5fdd23.svg";